import { ProviderType } from "components/integrations/managed_integrations/types";

export function buildContentLibraryPath(
  provider: ProviderType | "uploads",
  path?: string | string[],
): string {
  const pathString = Array.isArray(path) ? path.join("/") : path ?? "";

  let result = `/content-library/${provider}`;

  if (pathString) {
    result += `/${pathString}`;
  }

  return result;
}
